import axios from 'axios'

/** 调试请求：不因 4xx/5xx 抛错，便于展示完整响应 */
const http = axios.create({
  timeout: 120000,
  validateStatus: () => true
})

export default http
